import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tbys5jk9cz: FaireBrandEntity = {
  token: "b_tbys5jk9cz",
  type: "brand",
  name: "Aier Wholesale",
  avatarUrl:
    "https://cdn.faire.com/fastly/a52f87b88206b18a00c91511f3f7b8f86c568a448a550fae255838b14c21a87a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/007c9802f81889de2a66594801cbdb27d973cabc428ad7ad21dbd642f63b922f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a52f87b88206b18a00c91511f3f7b8f86c568a448a550fae255838b14c21a87a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/007c9802f81889de2a66594801cbdb27d973cabc428ad7ad21dbd642f63b922f.png",
  location: "Prosper, TX, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 883,
  isInsider: false,
  description:
    "     Hey Guys,thank you for your attention~No Tariff!We ship by our own!\nThere is 5%discount over $200 item value,10%discount over $600,20%discount over $2000\nShipping fee is 25%of the item cost.You can see if you have free shipping with insider with faire.\n\n      10 years ago,Aier Start her selling to usa with 2 machines to make herself,and now she got a big factory with over 100workers and 5 stairs warehouse full of boutique styles.With selling and designing experience to bring retailers best price and service!\n      All orders ship from China,we will ship in 2-4days after payment and about 7-10days delivery time!\nIf you need know approximately shipping fee,please message me with quantity you want to order!\nEnjoy your shopping :)\nIf you have any question please contact me first we will do best to solve the problem :) ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:30.906Z",
    importedBy: "entity-db-cli",
  },
};
